module.exports = __webpack_public_path__ + "static/media/8.0c5374e8.jpg";